import './Conents.styles.css';
import dayjs from 'dayjs';
import { Pagination, Tabs } from 'antd';
import { ArticleCard } from '../../../../components/article-card/ArticleCard.tsx';
import { useTranslation } from 'react-i18next';
import { useService } from '../../Dashboard.hooks.ts';
import type { RegulationCardType } from '../../Dashboard.types.ts';
import { useState } from 'react';

export default function Content() {
  const [activeKey, setActiveKey] = useState('1');

  // Pagination state for each tab
  const [newestPage, setNewestPage] = useState(1);
  const [updatedPage, setUpdatedPage] = useState(1);
  const [mostViewedPage, setMostViewedPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const { newestRegulations, updatedRegulations, mostViewedRegulations } = useService({
    type: [],
    unit: [],
    search: null,
    topic: null,
    activeKey,
    pageSize,
    newestPage,
    updatedPage,
    mostViewedPage,
  });
  const { t } = useTranslation();
  const handleChangeTab = (key: string) => {
    setActiveKey(key);
  };

  const NewestRegulations = () => {
    return (
      <>
        {newestRegulations?.items?.map((regulation: RegulationCardType) => (
          <ArticleCard
            id={regulation.id}
            title={regulation.title}
            type={regulation.type}
            status={dayjs(regulation.publicationDate).format('DD.MM.YYYY') || 'Not set'}
            shortDescription={regulation.shortDescription}
            key={regulation.id}
          />
        ))}
        <Pagination
          current={newestPage}
          pageSize={pageSize}
          showSizeChanger={true}
          onShowSizeChange={(_, _pageSize) => setPageSize(_pageSize)}
          total={newestRegulations?.totalCount}
          onChange={(page) => setNewestPage(page)}
          style={{ marginTop: 16, textAlign: 'center' }}
        />
      </>
    );
  };

  const UpdatedRegulations = () => {
    return (
      <>
        {updatedRegulations?.items?.map((regulation: RegulationCardType) => (
          <ArticleCard
            id={regulation.id}
            title={regulation.title}
            type={regulation.type}
            status={dayjs(regulation.publicationDate).format('DD.MM.YYYY') || 'Not set'}
            shortDescription={regulation.shortDescription}
            key={regulation.id}
          />
        ))}
        <Pagination
          current={updatedPage}
          pageSize={pageSize}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          totalBoundaryShowSizeChanger
          total={updatedRegulations?.totalCount}
          onShowSizeChange={(_, _pageSize) => setPageSize(_pageSize)}
          onChange={(page) => setUpdatedPage(page)}
          style={{ marginTop: 16, textAlign: 'center' }}
        />
      </>
    );
  };

  const MostViewedRegulations = () => {
    return (
      <>
        {mostViewedRegulations?.items?.map((regulation: { regulation: RegulationCardType }) => (
          <ArticleCard
            id={regulation?.regulation?.id}
            title={regulation?.regulation.title}
            type={regulation?.regulation.type}
            status={dayjs(regulation?.regulation.publicationDate).format('DD.MM.YYYY') || 'Not set'}
            shortDescription={regulation?.regulation.shortDescription}
            key={regulation?.regulation.id}
          />
        ))}
        <Pagination
          current={mostViewedPage}
          pageSize={pageSize}
          total={mostViewedRegulations?.totalCount}
          onShowSizeChange={(_, _pageSize) => setPageSize(_pageSize)}
          onChange={(page) => setMostViewedPage(page)}
          style={{ marginTop: 16, textAlign: 'center' }}
        />
      </>
    );
  };

  const tabs = [
    {
      key: '1',
      label: t('tab.newest'),
      children: <NewestRegulations />,
    },
    {
      key: '2',
      label: t('tab.updated'),
      children: <UpdatedRegulations />,
    },
    {
      key: '3',
      label: t('tab.most-viewed'),
      children: <MostViewedRegulations />,
    },
  ];

  return (
    <Tabs defaultActiveKey="1" items={tabs} activeKey={activeKey} onChange={handleChangeTab} />
  );
}
